import { formatProcent, formatUren } from '@/lib/format'
import { SOORT_KLEUR, type Verdeelvak } from '@/lib/inzet'
import { cn } from '@/lib/utils'

interface VerdeelbalkProps {
  vakken: Verdeelvak[]
  className?: string
}

function omschrijving(vakken: Verdeelvak[]): string {
  return vakken
    .map((vak) => `${vak.label} ${formatUren(vak.uren)} uur`)
    .join(', ')
}

/**
 * De uren van een medewerker of van het hele team, uitgesplitst naar soort. De
 * balansbalk zegt of het past; deze balk zegt waar de tijd in zit.
 */
export function Verdeelbalk({ vakken, className }: VerdeelbalkProps) {
  if (vakken.length === 0) return null

  return (
    <div className={cn('space-y-2.5', className)}>
      <div
        role="img"
        aria-label={omschrijving(vakken)}
        className="flex h-2.5 overflow-hidden rounded-full bg-fill-2"
      >
        {vakken.map((vak) => (
          <span
            key={vak.soort}
            className={cn('h-full origin-left animate-grow-bar-x', SOORT_KLEUR[vak.soort].vlak)}
            style={{ width: `${vak.aandeel * 100}%` }}
          />
        ))}
      </div>

      <ul className="flex flex-wrap items-center gap-x-4 gap-y-1">
        {vakken.map((vak) => (
          <li key={vak.soort} className="flex items-baseline gap-1.5 text-xs">
            <span
              aria-hidden="true"
              className={cn('h-2 w-2 shrink-0 translate-y-px rounded-[2px]', SOORT_KLEUR[vak.soort].vlak)}
            />
            <span className="text-ink-soft">{vak.label}</span>
            <span className="num text-ink-faint">
              {formatUren(vak.uren)} u · {formatProcent(vak.aandeel * 100)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
